<template>
    <div>
        <div class="row head">
            <div class="col col-100">Telefonie</div>
        </div>
        <div class="row row-single setting">
            <div class="col col-80"><span class="row__title">Individueel nummer wisselen</span></div>
            <div class="col col-20" v-if="$root.app.platform == 'android'">
                <div class="checkbox-wrap">
                    <input @change="insSwitch" class="cbx hidden" id="insSwitch" name="auth" type="checkbox" v-bind:checked="settings.numberSwitchIndividual == 1"/>
                    <label for="insSwitch" class="lbl"></label>
                </div>
            </div>
            <div class="col col-20 col-switch" v-if="$root.app.platform == 'ios'">
                <label for="insSwitch" class="switch">
                    <input @change="insSwitch" id="insSwitch" name="auth" type="checkbox" v-bind:checked="settings.numberSwitchIndividual == 1"/>
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div class="row setting row-last explanation">
            <div>
                Wanneer je "Individueel nummer wisselen" aan zet kunnen de op het account aangesloten smartphones zelf instellen met welk nummer ze uitgaand bellen.<br> Dit werkt alleen als je meerdere nummers en smartphones in het account hebt.
            </div>
        </div>
        <div class="row head">
            <div class="col col-100">Beveiliging</div>
        </div>
        <div class="row row-first setting">
            <div class="col col-80"><span class="row__title">Twee-staps verificatie</span></div>
            <div class="col col-20" v-if="$root.app.platform == 'android'">
                <div class="checkbox-wrap">
                    <input @change="authSwitch" class="cbx hidden" id="authSwitch" name="auth" type="checkbox" v-bind:checked="settings.twoStepVerification == 1"/>
                    <label for="authSwitch" class="lbl"></label>
                </div>
            </div>
            <div class="col col-20 col-switch" v-if="$root.app.platform == 'ios'">
                <label for="authSwitch" class="switch">
                    <input @change="authSwitch" id="authSwitch" name="auth" type="checkbox" v-bind:checked="settings.twoStepVerification == 1"/>
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div class="row setting row-last">
            <div class="col col-100" v-if="$root.app.platform == 'android'">
                <span class="row__title">Verificatie methode</span><br/>
                E-mail
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-70">
                <span class="row__title">Verificatie methode</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-30 text-right">
                <span class="row__subtitle">E-mail</span>
            </div>
        </div>
        <div class="row setting row-last explanation">
            <div>
                Wanneer je "Tweestaps verificatie" inschakelt wordt er tijdens het inloggen op de app een e-mail verstuurd welke bevestigd dient te worden. 
                Jouw account is op deze manier extra beveiligd.
            </div>
        </div>
        <div class="row head">
            <div class="col col-100">Communicatie</div>
        </div>
        <div class="row row-single setting">
            <div class="col col-80"><span class="row__title">Nieuwsbrief ontvangen</span></div>
            <div class="col col-20" v-if="$root.app.platform == 'android'">
                <div class="checkbox-wrap">
                    <input @change="newsletterSwitch" class="cbx hidden" id="newsletterSwitch" name="newsletter" type="checkbox" v-bind:checked="settings.newsletter == 1"/>
                    <label for="newsletterSwitch" class="lbl"></label>
                </div>
            </div>
            <div class="col col-20 col-switch" v-if="$root.app.platform == 'ios'">
                <label for="newsletterSwitch" class="switch">
                    <input @change="newsletterSwitch" id="newsletterSwitch" name="newsletter" type="checkbox" v-bind:checked="settings.newsletter == 1"/>
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
<!--        <div class="row setting row-last">
            <div class="col col-80"><span class="row__title">Serviceberichten ontvangen</span></div>
            <div class="col col-20" v-if="$root.app.platform == 'android'">
                <div class="checkbox-wrap">
                    <input @change="newsletterSwitch" class="cbx hidden" id="newsletterSwitch" name="newsletter" type="checkbox" v-bind:checked="settings.newsletter == 1"/>
                    <label for="newsletterSwitch" class="lbl"></label>
                </div>
            </div>
            <div class="col col-20 col-switch" v-if="$root.app.platform == 'ios'">
                <label for="newsletterSwitch" class="switch">
                    <input @change="newsletterSwitch" id="newsletterSwitch" name="newsletter" type="checkbox" v-bind:checked="settings.newsletter == 1"/>
                    <span class="slider round"></span>
                </label>
            </div>
        </div>-->
        
        <div class="row spacer">&nbsp;</div>
        
        <div class="row head">
            <div class="col col-100">Over My Dubline</div>
        </div>
        <div class="row setting row-first">
            <div class="col col-100" v-if="$root.app.platform == 'android'">
                <span class="row__title">Versie</span><br/>
                {{ $root.app.version }}
            </div>
            <div class="col col-50" v-if="$root.app.platform == 'ios'">
                <span class="row__title">Versie</span>
            </div>
            <div class="col col-50 text-right" v-if="$root.app.platform == 'ios'">
                <span class="row__subtitle">{{ $root.app.version }}</span>
            </div>
        </div>
        <div class="row setting row-last">
            <router-link to="/feedback">
            <div class="col col-100">
                <div class="small">{{ $root.app.notes }}</div>
            </div>
            </router-link>
        </div>
        
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
        
    </div>
</template>

<script>
    export default {
    name: 'Settings',
        data () {
            
            return {
                settings: []
            }
        },
        
        mounted(){
            
            
        },
        
        created(){

            this.$api.get('/settings')
            .then(response => {

                this.settings = response.data.settings;
            })
            .catch(e => {
                
            })
        },
        
        methods:{
            
            authSwitch: function(select){
                
                var i = (select.target.checked ? 1 : 0);
                
                this.$api.post('/settings', {
                    action: 'two-step-verification',
                    toggle: i
                })
                .then(response => {

                    
                })
                .catch(e => {
                    
                    
                })
            },
            
            insSwitch: function(select){
                
                var i = (select.target.checked ? 1 : 0);
                
                this.$api.post('/settings', {
                    action: 'individual-number-switch',
                    toggle: i
                })
                .then(response => {

                    
                })
                .catch(e => {
                    
                    
                })
            },
            
            newsletterSwitch: function(select){
                
                var i = (select.target.checked ? 1 : 0);
                
                this.$api.post('/settings', {
                    action: 'newsletter',
                    toggle: i
                })
                .then(response => {

                    
                })
                .catch(e => {
                    
                    
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue